import { Scale, Briefcase, Building2, Users, ShieldCheck, HeartPulse } from "lucide-react";

export const STUDIO = {
  name: "Studio Legale D'Arienzo",
  lawyer: "Avv. Federico D'Arienzo",
  address: "Via IV Novembre 25 (piano 5^)",
  city: "04100 - Latina",
  phoneLabel: "+39 0773 1647297",
  phoneHref: "tel:+3907731647297",
  whatsappHref:
    "https://wa.me/393381685944?text=" +
    encodeURIComponent("Buongiorno Avvocato, vorrei richiedere una consulenza."),
  email: "federicodarienzo@gmail.com",
  pec: "federicodarienzo@pec.it",
  mapQuery: "Via IV Novembre 25, 04100 Latina LT",
};

export const NAV = [
  { id: "aree", label: "Aree di attività" },
  { id: "perche", label: "Perché noi" },
  { id: "avvocato", label: "L'Avvocato" },
  { id: "metodo", label: "Metodo" },
  { id: "prenota", label: "Prenota" },
  { id: "contatti", label: "Contatti" },
];

export const AREAS = [
  {
    key: "lavoro",
    icon: Briefcase,
    title: "Lavoro e relazioni sindacali",
    intro: "Gestire le persone è la parte più delicata dell'impresa. Ti affianchiamo in ogni fase del rapporto di lavoro, per evitare errori che costano caro.",
    items: [
      "Contratti di assunzione, patti di non concorrenza e di prova",
      "Procedimenti disciplinari e licenziamenti individuali e collettivi",
      "Inquadramento, mansioni superiori e regolamenti interni",
      "Relazioni sindacali e accordi aziendali",
      "Infortuni sul lavoro e rapporti con INAIL",
      "Contenzioso davanti al giudice del lavoro",
      "Contratti di collaborazione, consulenza, agenzia e somministrazione",
    ],
  },
  {
    key: "societario",
    icon: Building2,
    title: "Societario, operazioni straordinarie e proprietà intellettuale",
    intro: "Dalla costituzione alla cessione, accompagniamo la vita della società. Con un obiettivo: decisioni rapide su basi solide.",
    items: [
      "Costituzione di società, statuti e patti parasociali",
      "Corporate governance, assemblee e consigli di amministrazione",
      "Cessioni e acquisizioni di quote e aziende, recesso e buy-back",
      "Due diligence legale su società e beni aziendali",
      "Joint venture, consorzi e contratti di rete",
      "Controversie tra soci e responsabilità degli amministratori",
      "Contrattualistica d'impresa: forniture, distribuzione, franchising, appalto e partnership commerciali",
      "Registrazione e tutela di marchi, brevetti e disegni industriali",
      "Contratti di licenza, cessione di know-how e accordi di riservatezza (NDA)",
      "Contrasto alla contraffazione e tutela dei nomi a dominio",
    ],
  },
  {
    key: "compliance",
    icon: ShieldCheck,
    title: "Compliance, Modello 231 e privacy",
    intro: "Un'organizzazione in regola è un'impresa più forte davanti a banche, clienti e pubbliche amministrazioni. Costruiamo strumenti su misura, non modelli fotocopia.",
    items: [
      "Mappatura dei rischi e Modello 231 (parte generale e speciale)",
      "Codice etico e sistema disciplinare",
      "Supporto all'Organismo di Vigilanza",
      "Adeguamento GDPR: informative, registri, nomine, data breach",
      "Formazione per amministratori, dirigenti e dipendenti",
    ],
  },
  {
    key: "contenzioso",
    icon: Scale,
    title: "Contenzioso civile, tributario e recupero crediti",
    intro: "Un credito non incassato è liquidità che manca. Agiamo in fretta, prima in via stragiudiziale e poi, se serve, in giudizio.",
    items: [
      "Diffide, piani di rientro e ricognizioni di debito",
      "Decreti ingiuntivi e procedure esecutive",
      "Contenzioso civile e commerciale",
      "Fideiussioni e garanzie bancarie",
      "Crisi d'impresa e procedure concorsuali",
      "Controversie su inadempimenti contrattuali, vizi e ritardi nelle forniture",
      "Consulenza e contenzioso tributario sui crediti d'imposta: Formazione 4.0, Ricerca e sviluppo, Transizione 4.0, Superbonus e bonus edilizi",
      "Difesa contro avvisi di recupero, accertamenti e cartelle, dal contraddittorio con l'Agenzia delle Entrate fino alla Corte di giustizia tributaria",
    ],
  },
  {
    key: "medica",
    icon: HeartPulse,
    title: "Responsabilità medica e risarcimento danni",
    intro: "Un errore medico o un incidente possono cambiare una vita. Valutiamo ogni caso con un medico legale prima di avviare qualsiasi azione.",
    items: [
      "Errori diagnostici e terapeutici, infezioni ospedaliere",
      "Responsabilità della struttura sanitaria",
      "Sinistri stradali e responsabilità civile",
      "Accertamento tecnico preventivo e mediazione",
    ],
  },
  {
    key: "famiglia",
    icon: Users,
    title: "Famiglia e persone",
    intro: "Nei momenti più difficili servono riservatezza e una guida chiara. Cerchiamo prima di tutto l'accordo.",
    items: [
      "Separazioni e divorzi, anche con negoziazione assistita",
      "Affidamento e mantenimento dei figli",
      "Amministrazione di sostegno",
      "Successioni e divisioni ereditarie",
      "Accordi di separazione e divorzio, patti di convivenza",
    ],
  },
];

export const PROMISES = [
  {
    key: "personale",
    quote: "Seguo personalmente ogni pratica, dall'inizio alla fine",
    title: "Un unico riferimento",
    text: "Parli sempre con l'avvocato che conosce il tuo caso, senza passaggi di mano.",
  },
  {
    key: "chiarezza",
    quote: "Spieghiamo tutto in modo chiaro, con preventivi trasparenti",
    title: "Chiarezza e trasparenza",
    text: "Sai cosa aspettarti in ogni fase e quanto costerà, prima di iniziare.",
  },
  {
    key: "rapidita",
    quote: "Rispondiamo in fretta, anche nei casi urgenti",
    title: "Risposte rapide",
    text: "Quando una scadenza incombe, lo studio si attiva senza farti attendere.",
  },
];

export const STEPS = [
  { n: "01", title: "Primo contatto", text: "Scrivi, chiama o prenota un appuntamento direttamente da questa pagina." },
  { n: "02", title: "Incontro e analisi", text: "Esaminiamo insieme la situazione e i documenti, con un linguaggio chiaro." },
  { n: "03", title: "Preventivo trasparente", text: "Ricevi una proposta di intervento con costi definiti prima di procedere." },
  { n: "04", title: "Seguito della pratica", text: "L'avvocato segue personalmente ogni passaggio, fino alla conclusione." },
];

export const SLOT_NOTE = "Ricevimento su appuntamento, dal lunedì al venerdì.";
